/**
 * Password field with show/hide toggle
 */

import { useState } from 'react';
import './PasswordInput.css';

export default function PasswordInput({
  id,
  name,
  value,
  onChange,
  label,
  labelClassName = '',
  placeholder,
  required = false,
  disabled = false,
  minLength,
  autoComplete = 'current-password',
  error,
  hint,
  hintId,
  className = '',
  showLabel = true,
}) {
  const [visible, setVisible] = useState(false);
  const describedBy = [
    error ? `${id}-error` : null,
    hint && hintId ? hintId : null,
  ]
    .filter(Boolean)
    .join(' ') || undefined;

  return (
    <div className={`password-input-wrapper ${className}`.trim()}>
      {showLabel && label && (
        <label htmlFor={id} className={labelClassName}>
          {label}
        </label>
      )}
      <div className={`password-input-field ${error ? 'has-error' : ''}`}>
        <input
          type={visible ? 'text' : 'password'}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          minLength={minLength}
          autoComplete={autoComplete}
          aria-required={required || undefined}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          className={error ? 'error' : ''}
        />
        <button
          type="button"
          className="password-input-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          aria-pressed={visible}
          tabIndex={0}
          disabled={disabled}
        >
          {visible ? '🙈' : '👁️'}
        </button>
      </div>
      {error && (
        <div id={`${id}-error`} className="field-error" role="alert">
          {error}
        </div>
      )}
      {hint && (
        <small id={hintId} className="form-hint">
          {hint}
        </small>
      )}
    </div>
  );
}
